import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createApplicationStore } from '#store/createApplicationStore.ts';
import { createCookieStorage } from '#store/createCookieStorage.ts';
import { createFavoritesStore } from '#store/createFavoritesStore.ts';
import { createRecentlyWatchedStore } from '#store/createRecentlyWatchedStore.ts';
import { createShortcutsStore } from '#store/createShortcutsStore.ts';
import { createWatchlistStore } from '#store/createWatchlistStore.ts';
import { createContinueWatchingStore } from './createContinueWatchingStore.ts';
import { type State, type Store } from './types.ts';

const initialState: Partial<State> = {
  additionalCookiesAccepted: undefined,
  continueWatchingTv: [],
  favorites: [],
  recentlyWatchedMovies: [],
  recentlyWatchedTv: [],
  shortcuts: [],
  watchlist: [],
};

export const createStore = (state: Partial<State> = {}) => {
  const stateWithDefaults = { ...initialState, ...state };

  return create(
    persist<Store>(
      (...args) => ({
        ...createApplicationStore(stateWithDefaults)(...args),
        ...createContinueWatchingStore(stateWithDefaults)(...args),
        ...createFavoritesStore(stateWithDefaults)(...args),
        ...createRecentlyWatchedStore(stateWithDefaults)(...args),
        ...createShortcutsStore(stateWithDefaults)(...args),
        ...createWatchlistStore(stateWithDefaults)(...args),
      }),
      { name: 'dollygrip-store', storage: createJSONStorage(() => createCookieStorage()) },
    ),
  );
};
